var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hrPicoResponsivo"},[_c('Chart',{staticClass:"mb-3 d-none d-sm-none d-md-block",attrs:{"type":"line","data":_vm.basicData,"options":_vm.options}}),_c('Chart',{staticClass:"mb-3 d-block d-sm-block d-md-none graficaResponsiva",attrs:{"type":"line","data":_vm.basicData,"options":_vm.options}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }